import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import {RdfsLabelRequest, PredicatSubjectRequest, CountSubjectRequest,
    DCTermsDescriptionRequest} from '../virtuoso/request';

/** Специальные действия для получения информации об онтологии
 * Например, наименование свойств
 */
export const OwlRepository = {
    EMPTY: () => ({
        type: OwlRepository.EMPTY,
    }),
    LOAD_STARTED: () => ({
        type: OwlRepository.LOAD_STARTED,
    }),
    LOAD_ERROR: (error) => ({
        type: OwlRepository.LOAD_ERROR, 
        error,
    }),
    LOAD_LABELS: (graph, iri, values) => ({
        type: OwlRepository.LOAD_LABELS,
        graph, iri, values
    }),
    LOAD_DESCRIPTIONS: (graph, iri, values) => ({
        type: OwlRepository.LOAD_DESCRIPTIONS,
        graph, iri, values
    }),

    /** Загрузить информацию о метках  */
    loadLabels: (iri, lang, graph) => dispatch => {
        const options = {...settings.options};
        RdfsLabelRequest.setURI(iri);
        return ApiUtils.query(RdfsLabelRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_LABELS(graph, iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию об описаниии значение для предиката http://purl.org/dc/terms/description  */
    loadDescription: (iri, graph) => dispatch => {
        const options = {...settings.options};
        DCTermsDescriptionRequest.setURI(iri);
        return ApiUtils.query(DCTermsDescriptionRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_DESCRIPTIONS(graph, iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
    /** Загрузить информацию о таксономии каталога. Является вспомогательной частью описания каталога.
     * Отслеживать процесс загрузки нет необходимости, так как требуется только для фильтрации в UI. */
    loadThemeTaxonomy: () => dispatch => {
        const options = {...settings.options};
        admsAssets.request.offset = 0;
        admsAssets.request.limit = settings.defaultLimit;
        return ApiUtils.query(admsThemeTaxonomy, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_THEMETAXONOMY(bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    loadTaxonomy: taxonomy => dispatch => {
        const options = {...settings.options};
        console.log("skosConceptInScheme.request", skosConceptInScheme.request.where[0].triples[2]);
        skosConceptInScheme.setConceptScheme(taxonomy);
        //skosConceptInScheme.request.prefixes.IRI_SCHEMA = taxonomy;
        //skosConceptInScheme.request.where[0].triples[2]["object"].id = taxonomy;
        console.log("skosConceptInScheme.request", skosConceptInScheme.request);
        console.log("skosConceptInScheme.sparql", skosConceptInScheme.sparql);
        return ApiUtils.query(skosConceptInScheme, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_TAXONOMY(taxonomy, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    }
};

export const RdfTriplet = {
    EMPTY: () => ({
        type: RdfTriplet.EMPTY,
    }),
    ACTION_STARTED: () => ({
        type: RdfTriplet.ACTION_STARTED
    }),
    ERROR: (error) => ({
        type: RdfTriplet.ERROR, 
        error,
    }),
    SELECTED: (operation, subject, predicat, value) => ({
        type: RdfTriplet.SELECTED,
        operation, subject, predicat, value
    }),
    UPDATE: (graph, iri, values) => ({
        type: RdfTriplet.UPDATE,
        graph, iri, values
    }),

    /** Загрузить информацию о субъекте. subject - iri субъекта. Возвращает триплеты */
    loadSubject: (subject, graph) => {
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(subject);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            });
    }, 

    update: (iri, graph) => dispatch => {
        const options = {...settings.options};
        rdfsLabel.setURI(iri);
        return ApiUtils.query(rdfsLabel, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_LABELS(graph, iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    countSubject: (subject, graph) => {
        const options = {...settings.options};
        //console.log(CountSubjectRequest.request);
        CountSubjectRequest.setIRI(subject);
        //console.log(CountSubjectRequest.request);
        return ApiUtils.query(CountSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            });        
    },

};
